document.addEventListener('DOMContentLoaded', () => {
    const cookieMessage = document.querySelector('.cookie-message')
    const cookieAcceptBtn = cookieMessage.querySelector('.cookie-message__accept-btn')

    const accept_terms = sessionStorage.getItem('cookie__accept_terms')

    if(cookieMessage && accept_terms !== '1') {
        cookieMessage.style.display = 'flex';
    }

    if(cookieAcceptBtn) {
        cookieAcceptBtn.addEventListener('click', () => {
            sessionStorage.setItem('cookie__accept_terms', '1')
            cookieMessage.style.display = 'none'
        })
    }    
})